@for (camera of rowCameras(); track $index) {
  <app-pan-video-status
    class="cursor-pointer"
    [status]="camera.status === 'GREEN' ? 'healthy' : 'unhealthy'"
    (click)="cameraModal.show()"
  ></app-pan-video-status>

  <app-pan-modal #cameraModal>
    <div header>{{ camera.camera_name }}</div>

    <div body class="flex flex-col justify-center items-center gap-2">
      <table class="table">
        <tbody>
          <tr>
            <td class="font-bold">Serial Number</td>
            <td>{{ camera.serial_number }}</td>
          </tr>
          <tr>
            <td class="font-bold">Camera ID</td>
            <td>{{ camera.id }}</td>
          </tr>
          <tr>
            <td class="font-bold">Bandwidth Consumed</td>
            <td>{{ humanFileSize(camera.bandwidth_consumed) }}</td>
          </tr>
          <tr>
            <td class="font-bold">Health</td>
            <td>{{ camera.status }}</td>
          </tr>
          <tr>
            <td class="font-bold">Connection</td>
            <td>{{ camera.connectivity_type ?? "unknown" }}</td>
          </tr>
          <tr>
            <td class="font-bold">DNS Hostname</td>
            <td>{{ camera.dns_hostname ?? "unknown" }}</td>
          </tr>
          <tr>
            <td class="font-bold">ISP</td>
            <td>{{ camera.isp_name ?? "unknown" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div footer>
      <button panButton panModalClose>Close</button>
    </div>
  </app-pan-modal>
}
